import type { AtLeast } from '#layers/base/public';
import type { BlockSerializedChild, BlockSerializedSlotOutlet } from '#layers/block-engine/public';
import type { MonospaceBlock } from '#layers/data-model/public';

export function blockRenderDataFactory(block: AtLeast<Omit<NonNullable<MonospaceBlock['renderData']>, 'children'>, 'rootChildren'> & {
	children: Record<string, AtLeast<Omit<BlockSerializedChild, 'id'>, 'blockId'> | AtLeast<Omit<BlockSerializedSlotOutlet, 'id'>, 'slotName'>>;
}): NonNullable<MonospaceBlock['renderData']> {
	const children: Record<string, BlockSerializedChild | BlockSerializedSlotOutlet> = {};

	for (const [key, value] of Object.entries(block.children)) {
		if ('blockId' in value) {
			// It's a child block
			children[key] = {
				id: key,
				props: {},
				slots: {},
				...value,
			} satisfies BlockSerializedChild;
		}
		else if ('slotName' in value) {
			// It's a slot outlet
			children[key] = {
				id: key,
				props: {},
				...value,
			} satisfies BlockSerializedSlotOutlet;
		}
	}

	return {
		variables: [],
		props: [],
		events: [],
		slots: [],
		...block,
		children,
	};
}
